import Collapsible, { Collapse, Expand } from '../../../interface/Collapsible.js';
import EL from '../../EL/EL.js';
import LI from '../../DOM/LIST/li/LI.js';
import { LISTTYPES } from '../../../enums/LISTTYPES.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
// Model Structure
export const listAttr = makeAttrStruct([
    ['type', LISTTYPES.UL],
    ['name'],
    ['class'],
    ['style'],
    ['start', 0],
    ['reversed', false],
]);
/** An abstract List Constructor containing a Collection of ListItems */
export default class LIST extends EL {
    // declare public el: HTMLUListElement;
    constructor(node, element, model) {
        super(node, element, model);
        // this.addClass('list');
        this.addConstructor('LI', this.addLI.bind(this));
        this.implement(new Collapsible(this));
        this.on('collapse', () => {
            if (this.el.children.length > 0) {
                //console.log('TODO: EMPTYING ' + this.className + '[' + this.name + ']', this.className); //this
            }
        });
        this.on('expand', () => {
            //console.log('TODO: POPULATING ' + this.className + '[' + this.name + ']');
        });
    }
    /** Construct a generic List Item (LI) and append to this element's children */
    addLI(model) {
        return this.addChild(new LI(this, model));
    }
}
export { Collapse, Collapsible, EL, Expand, LI };
